<div class="games-container" style="min-height: 500px">
  <h3>{{ username }}</h3>

  <h4>Games</h4>
  <app-games [initialFilter]="{ eventCollectorName: username }"></app-games>
</div>
